// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
import type {
  IDesktopGetRecommendationsRequest,
  TDesktopGetRecommendationsModel,
  IMappers,
  TDesktopGetRecommendationsResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IGetRecommendationsResponseV2 } from '../../../entities/recommendations/GetRecommendationsResponseV2';
import type { IErrorResponseSchema } from '../../../entities/schemas/ErrorResponseSchema';

export function createDesktopGetRecommendationsModel(
  parameters: IDesktopGetRecommendationsRequest,
): TDesktopGetRecommendationsModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'GET',
    microserviceName: 'feed-page',
    pathApi: '/v2/desktop/get-recommendations/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      parameters,
    },
  };
}

export interface IDesktopGetRecommendationsOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IDesktopGetRecommendationsRequest;
}

export async function fetchDesktopGetRecommendations<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IDesktopGetRecommendationsOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TDesktopGetRecommendationsResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createDesktopGetRecommendationsModel(parameters),
    config,
  )) as FetchResponse<TDesktopGetRecommendationsResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetRecommendationsResponseV2, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }

  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TDesktopGetRecommendationsResponse>;
}
